import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

require('jquery-jcrop');
require('../../sass-main/pdc-widget-resource-manager.sass');

import { store as RMStore, actions as RMActions } from '../flux/glob';
import StringField from '../../../../_common/platform/tsx/StringField';
import { ProgressBar } from '../../../../_common/platform/tsx/ProgressBar';

export interface IImageResourceDialogResourceValue {
    resId: string;
    selection?;
    name?: string;
}

export default class ImageResourceDialog extends React.Component<
    {
        setConfirmValueGetter(callback);
        unsetConfirmValueGetter();

        options: {
            instanceId;
            selectedDirId;
            editMode: boolean;
            resourceValue: IImageResourceDialogResourceValue;
        };
    },
    any
> {
    displayName: string = 'ImageResourceDialog';

    private jcrop_api;

    public static defaultProps = {
        obj: {}
    };

    private references: {
        img?: HTMLElement; // HTMLDivElement;
        fileUpload?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = _.extend(this.getState(), {
            resourceName: '',
            fileName: null,
            mimetype: '',
            data: 'assets/default-human.jpg',
            width: 100,
            height: 100,
            saveEdited: false,
            uploadingImage: false,
            resourceLoaded: false,
            cropMode: false
        });

        this.handleCropUpload = this.handleCropUpload.bind(this);
    }

    getState() {
        const RMState = RMStore.getInstanceState(this.props.options.instanceId);

        return {
            RMState
        };
    }

    componentDidMount() {
        RMStore.addChangeListener(this.handleOnChange);

        //LL: 31.01.25: from WillMount
        let obj = this.props.setConfirmValueGetter(
            // Was: this.obj = this.props.setConfirmValueGetter(
            this.handleCropUpload
        );
        this.setState(
            _.extend(this.getState(), {
                resourceName: '',
                fileName: null,
                mimetype: '',
                data: 'assets/default-human.jpg',
                width: 100,
                height: 100,
                saveEdited: false,
                uploadingImage: false,
                resourceLoaded: false,
                cropMode: false
            })
        );

        if (this.props.options.editMode) {
            RMActions.getData(this.props.options.instanceId, this.props.options.resourceValue.resId);
        }
    }

    //LL: 31.01.25: to DidMount
    // componentWillMount() {
    //     let obj = this.props.setConfirmValueGetter(
    //         // Was: this.obj = this.props.setConfirmValueGetter(
    //         this.handleCropUpload
    //     );

    //     this.setState(
    //         _.extend(this.getState(), {
    //             resourceName: '',
    //             fileName: null,
    //             mimetype: '',
    //             data: 'assets/default-human.jpg',
    //             width: 100,
    //             height: 100,
    //             saveEdited: false,
    //             uploadingImage: false,
    //             resourceLoaded: false,
    //             cropMode: false
    //         })
    //     );
    // }

    componentWillReceiveProps(nextProps) {
        this.setState(
            _.extend(this.getState(), {
                resourceName: nextProps.options.resourceValue.name
            })
        );
    }

    componentWillUnmount() {
        //RMActions.zeroFlags(this.props.options.instanceId);
        RMStore.removeChangeListener(this.handleOnChange);

        if (typeof this.props.unsetConfirmValueGetter === 'function') {
            this.props.unsetConfirmValueGetter();
        }
    }

    handleOnChange = () => {
        const rmState = RMStore.getInstanceState(this.props.options.instanceId);

        if (
            this.props.options.resourceValue.resId === '0' ||
            rmState.selectedResources[this.props.options.resourceValue.resId] != null
        ) {
            if (rmState.resourceData != null) {
                let mimetype = rmState.resourceData.mimetype;
                let dataUrl = 'data:' + mimetype + ';base64,' + rmState.resourceData.data;

                this.setState(
                    _.extend(this.getState(), {
                        mimetype: mimetype,
                        data: dataUrl,
                        resourceLoaded: true
                    })
                );

                if (this.isImage(mimetype)) {
                    let imgComponent = this.references.img;

                    if (imgComponent) {
                        let img = imgComponent;
                        this.resizeImage(this, dataUrl, 0, 0, 500, 500, img);
                    }
                }
            }
        }
    };

    handleSaveEdited = (e) => {
        this.setState(
            _.extend(this.getState(), {
                saveEdited: e.target.checked
            })
        );
    };

    handleNameChanged = (val) => {
        this.setState(
            _.extend(this.getState(), {
                resourceName: val
            })
        );
    };

    handleCropUpload = () => {
        let resId = this.props.options.resourceValue.resId;
        let dirid = this.props.options.selectedDirId;
        let name = this.state.resourceName;
        let mimetype = this.state.mimetype;

        if (this.state.saveEdited && this.isImage(mimetype)) {
            let coords = this.props.options.resourceValue.selection;
            let img = this.references.img as HTMLImageElement;
            let data = img.src;

            this.cropUploadFromDialog(dirid, resId, img, data, coords, name, mimetype);
        } else {
            let fInput = this.references.fileUpload;

            RMStore.postUpload(
                fInput,
                this.props.options.editMode,
                this.props.options.instanceId,
                this.state.resourceName,
                this.props.options.selectedDirId,
                resId,
                name
            );
        }
    };

    private isImage(mimeType: string): boolean {
        return mimeType.indexOf('image/') === 0;
    }

    uploadImage = (dirid, data, name_extension, mimetype) => {
        let name = name_extension.substr(0, name_extension.lastIndexOf('.')) || name_extension;

        if (this.props.options.editMode) {
            let resId = this.props.options.resourceValue.resId;

            RMActions.resourceRenameFinish(this.props.options.instanceId, resId, name);
            RMActions.uploadData(this.props.options.instanceId, dirid, resId, mimetype, data);
        } else {
            RMActions.create(this.props.options.instanceId, dirid, name, mimetype, data);
        }
    };

    cropUploadFromDialog = (dirid, resId, img, data, coords, name, mimetype) => {
        let self: any = this;
        let imgData = data;
        let canvas = document.createElement('canvas');

        let imgInCont = this.references.img as HTMLImageElement;
        if (coords == null) {
            let size = img.width > img.height ? img.height : img.width;
            coords = {
                x: img.width / 2 - size / 2,
                y: img.height / 2 - size / 2,
                w: size,
                h: size
            };
        }
        canvas.width = coords.w;
        canvas.height = coords.h;

        if (parseInt(coords.w) > 0) {
            let tempImg = new Image();

            if (imgData.substring(0, 4).toLowerCase() === 'http') {
                tempImg.crossOrigin = 'Anonymous';
            }

            tempImg.onload = function () {
                let ctx = canvas.getContext('2d');
                ctx.drawImage(tempImg, coords.x, coords.y, coords.w, coords.h, 0, 0, canvas.width, canvas.height);
                let dataURL = canvas.toDataURL(self.state.mimeType);
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                imgInCont.src = dataURL;
                self.uploadImage(dirid, dataURL, name, mimetype);
            };

            tempImg.onerror = function () {
                self.setState(
                    _.extend(self.state, {
                        data: 'assets/default-human.jpg',
                        width: 100,
                        height: 100
                    })
                );
                return;
            };

            tempImg.src = imgData;

            if (tempImg.src.match('') != null) {
                self.setState(
                    _.extend(self.state, {
                        data: 'assets/default-human.jpg',
                        width: 100,
                        height: 100
                    })
                );
            }
        }
    };

    handleDragEnter = (e) => {
        e.stopPropagation();
        e.preventDefault();
        e.target.className = 'drag-enter-area';
    };

    handleDragOver = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    handleDrop = (e) => {
        e.preventDefault();
        e.target.className = 'droped-area';
        let fileUpload = this.references.fileUpload as any;
        fileUpload.files = e.dataTransfer.files;

        this.handleTakePicture();
    };

    onCropSelect = () => {
        this.checkSaveEdited();
        this.getCoords();
    };

    onCropChange = () => {
        this.getCoords();
    };

    preventDeselection = (e) => {
        this.setCropDefaultSelection();
    };

    getCoords = () => {
        if (this.jcrop_api) {
            let selection = this.jcrop_api.tellSelect();
            this.props.options.resourceValue.selection = selection;
        }
    };

    initJcrop = () => {
        if (this.jcrop_api) {
            this.jcrop_api.destroy();
        }

        if (this.state.cropMode) {
            let img = this.references.img as HTMLImageElement;

            this.jcrop_api = $.Jcrop(img, {
                bgOpacity: 0.5,
                bgColor: 'white',
                addClass: 'jcrop-light',
                bgFade: true,
                keySupport: false,
                allowSelect: true,
                allowMove: true,
                allowResize: true,
                allowRelease: true,
                //minSize: [ 100, 100 ],
                aspectRatio: 1,
                onSelect: this.onCropSelect,
                onChange: this.onCropChange,
                onRelease: this.preventDeselection
            });
            this.jcrop_api.setOptions({ bgFade: true });
            this.setCropDefaultSelection();
        }
    };

    setCropDefaultSelection = () => {
        let img = this.references.img as HTMLImageElement;
        let width = img.width;
        let height = img.height;
        let size = width > height ? height : width;
        let selection = [width / 2 - size / 2, height / 2 - size / 2, width / 2 + size / 2, height + size / 2];
        this.jcrop_api.setSelect(10, 10, width - 10, height - 10);
        this.jcrop_api.focus();
    };

    resizeImage = (This, sourceData, x, y, w, h, img) => {
        let self = this;
        let canvas = document.createElement('canvas');
        let tempImg = new Image();
        if (sourceData.substring(0, 4).toLowerCase() === 'http') {
            tempImg.crossOrigin = 'Anonymous';
        }

        tempImg.onload = function () {
            let MAX_WIDTH = w;
            let MAX_HEIGHT = h;
            let tempW = tempImg.width;
            let tempH = tempImg.height;
            if (tempW > tempH) {
                if (tempW > MAX_WIDTH) {
                    tempH *= MAX_WIDTH / tempW;
                    tempW = MAX_WIDTH;
                }
            } else {
                if (tempH > MAX_HEIGHT) {
                    tempW *= MAX_HEIGHT / tempH;
                    tempH = MAX_HEIGHT;
                }
            }

            canvas.width = tempW;
            canvas.height = tempH;
            let ctx = canvas.getContext('2d');
            ctx.drawImage(tempImg, x, y, tempW, tempH);
            let dataURL = canvas.toDataURL(self.state.mimetype);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            This.setState(
                _.extend(This.state, {
                    data: dataURL,
                    width: tempW,
                    height: tempH
                })
            );
        };

        tempImg.onerror = function () {
            let elem: any = this;
            if (elem.jcrop_api) {
                elem.jcrop_api.destroy();
            }

            This.setState(
                _.extend(This.state, {
                    data: 'assets/default-human.jpg',
                    width: 100,
                    height: 100
                })
            );
            return;
        };

        tempImg.src = sourceData;
    };

    checkSaveEdited = () => {
        this.setState(
            _.extend(this.state, {
                saveEdited: true
            })
        );
    };

    handleRotateLeft = () => {
        this.rotate(270);
        this.checkSaveEdited();
    };

    handleRotateRight = () => {
        this.rotate(90);
        this.checkSaveEdited();
    };

    toggleCrop = () => {
        if (this.state.cropMode == true) {
            this.props.options.resourceValue.selection = null;
        }

        let curCropMode = this.state.cropMode;

        this.setState(
            _.extend(this.state, {
                cropMode: !curCropMode
            })
        );
        this.initJcrop();
    };

    rotate = (value) => {
        let self = this;

        this.setState(
            _.extend(this.state, {
                cropMode: false
            })
        );

        if (this.jcrop_api) {
            this.jcrop_api.destroy();
        }

        let img = this.references.img as HTMLImageElement;
        let imgData = img.src;
        let degree = Math.round(value);
        let cw = img.width,
            ch = img.height,
            cx = 0,
            cy = 0;

        switch (degree) {
            case 90:
                cw = img.height;
                ch = img.width;
                cy = img.height * -1;
                break;
            case 180:
                cx = img.width * -1;
                cy = img.height * -1;
                break;
            case 270:
                cw = img.height;
                ch = img.width;
                cx = img.width * -1;
                break;
        }

        let tempImg = new Image();
        if (imgData.substring(0, 4).toLowerCase() === 'http') {
            tempImg.crossOrigin = 'Anonymous';
        }

        tempImg.onload = function () {
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            canvas.setAttribute('width', cw.toString());
            canvas.setAttribute('height', ch.toString());
            ctx.rotate((degree * Math.PI) / 180);
            ctx.drawImage(tempImg, cx, cy);
            let dataURL = canvas.toDataURL(self.state.mimeType);

            self.setState(
                _.extend(self.state, {
                    data: dataURL,
                    width: cw,
                    height: ch
                })
            );
            ctx.clearRect(0, 0, cw, ch);
        };

        tempImg.src = imgData;
    };

    handleBrowseClick = () => {
        let fileInput = this.references.fileUpload as HTMLInputElement;
        fileInput.click();
    };

    handleTakePicture = () => {
        let fileInput = this.references.fileUpload as any;

        let files = fileInput.files;
        if (files == null || files.length == 0) {
            return;
        }

        this.setState(
            _.extend(this.state, {
                resourceName: files[0].name,
                fileName: files[0].name,
                mimetype: files[0].type,
                resourceLoaded: true
            })
        );

        RMActions.loadFromFile(this.props.options.instanceId, files[0]);
    };

    handleImageLoad = () => {};

    handleOnOriginalDataChanged = () => {};

    handleDeleteImage = () => {
        this.setState(
            _.extend(this.state, {
                data: 'assets/default-human.jpg',
                width: 100,
                height: 100
            })
        );
    };

    private getRotateButtons() {
        if (this.state.resourceLoaded && this.isImage(this.state.mimetype)) {
            let cropClass = 'btn ' + (this.state.cropMode ? 'btn-primary' : 'btn-default');

            return (
                <div>
                    <hr />
                    <div style={{ float: 'left' }}>
                        <button
                            type="button"
                            className="btn btn-default"
                            title="Rotate counterclockwise"
                            onClick={this.handleRotateLeft}
                        >
                            <span className="fa fa-rotate-left"></span>
                        </button>
                        <button
                            type="button"
                            className="btn btn-default"
                            title="Rotate clockwise"
                            onClick={this.handleRotateRight}
                        >
                            <span className="fa fa-rotate-right"></span>
                        </button>
                    </div>
                    <div style={{ float: 'left', marginLeft: '5px' }}>
                        <button type="button" className={cropClass} title="Crop Image" onClick={this.toggleCrop}>
                            <span className="fa fa-crop"></span>
                        </button>
                    </div>
                </div>
            );
        }
    }

    private getImagePreview() {
        const RMState = RMStore.getInstanceState(this.props.options.instanceId);
        if (RMState.loadingImage) {
            return <ProgressBar />;
        }

        if (this.state.resourceLoaded && this.isImage(this.state.mimetype)) {
            let style: any = {
                width: this.state.width,
                height: this.state.height
            };
            let imgStyle = style;
            imgStyle.backgroundImage =
                'linear-gradient(to right, rgba(192, 192, 192, 0.75), rgba(192, 192, 192, 0.75)), linear-gradient(to right, black 50%, white 50%), linear-gradient(to bottom, black 50%, white 50%)';
            imgStyle.backgroundBlendMode = 'normal, difference, normal';
            imgStyle.backgroundSize = '2em 2em';
            return (
                <div
                    className="dropped-area"
                    style={style}
                    onDragEnter={this.handleDragEnter}
                    onDragOver={this.handleDragOver}
                    onDrop={this.handleDrop}
                >
                    <img
                        ref={(input) => {
                            this.references.img = input;
                        }}
                        style={imgStyle}
                        onLoad={this.handleImageLoad}
                        src={this.state.data}
                    />
                </div>
            );
        }
    }

    // private getSaveEditedData() {
    //     if (this.isImage(this.state.mimetype)) {
    //         return (
    //             <label key="saveEdited">
    //                 <input type="checkbox" checked={this.state.saveEdited} onChange={this.handleSaveEdited} />

    //                 <span> {'Save Edited Data'} </span>
    //             </label>
    //         );
    //     }
    // }

    private getResourceEditControls() {
        if (this.state.resourceLoaded) {
            return <StringField value={this.state.resourceName} onChange={this.handleNameChanged} />;
        } else {
            let _text = this.state.editMode ? '' : 'File is not selected';
            return <label>{_text}</label>;
        }
    }

    private getContent = () => {
        //const RMState = RMStore.getInstanceState(this.props.options.instanceId);
        let errors = [];
        //let resId = this.props.options.resourceValue.resId;
        //let resImage = this.props.options.resourceValue.resImage + "?" + new Date().getTime();

        let fileUploadText = this.props.options.editMode ? 'Replace' : 'Select file';

        /* $(document).ready(function () {
             let f: any = $("#input-folder-3");
             if (f.fileinput) {
                 f.fileinput({
                     uploadUrl: config.ASSETS_PATH_ROOT + "/chess.png",
                     hideThumbnailContent: true // hide image, pdf, text or other content in the thumbnail preview
                 });
             }
         });
           <label htmlFor="input-folder-3">Select files/folders</label>
         */
        return (
            <div className="pdc-widget-resource-manager">
                <div />
                <div>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td className="td-border-none">
                                    <div className="file-loading">
                                        <input
                                            id="input-folder-3"
                                            name="input-folder-3[]"
                                            ref={(input) => {
                                                this.references.fileUpload = input;
                                            }}
                                            type="file"
                                            className="invisible"
                                            onChange={this.handleTakePicture}
                                        />
                                    </div>
                                    <input
                                        className="btn btn-default"
                                        type="button"
                                        value={fileUploadText}
                                        onClick={this.handleBrowseClick}
                                    />{' '}
                                    {this.getResourceEditControls()}
                                    {this.getRotateButtons()}
                                </td>
                            </tr>
                            <tr>
                                <td className="td-border-none">{this.getImagePreview()}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="errors">{errors.join(', ')}</div>
            </div>
        );
    };

    render() {
        return <div>{this.getContent()}</div>;
    }
}
